<template>
  <div>
    <v-info-form :title="title" @close="cancel()">
        <v-card-text>
          <v-layout column>
            <v-flex>
             <b>{{item.code}}</b> от {{formats.blank(item.date, formats.formatDate)}}
            </v-flex>
            <v-flex>
             Номер: <b>{{item.grnip}}</b>
            </v-flex>
            <v-flex>
              {{item.name}}
            </v-flex>
            <v-flex>
              <b>{{formats.blank(item.date, formats.formatDate)}}</b> - {{formats.blank(formats.getValue(item, ['tax', 'name']))}} ({{formats.blank(formats.getValue(item, ['tax', 'code']))}}) 
            </v-flex>
            <v-flex v-show="item.documents != null">
              Документы:
              <template v-for="doc in item.documents">
                <v-flex pl-2>
                  <b>{{formats.blank(formats.getValue(doc, ['date']), formats.formatDate)}}</b> - {{formats.blank(formats.getValue(doc, ['name']))}} ({{formats.blank(formats.getValue(item, ['number']))}}) 
                </v-flex>
              </template>
            </v-flex>
            <v-flex v-show="item.certificates != null">
              Свидетельства:
              <template v-for="cert in item.certificates">
                <v-flex pl-2>
                  <b>{{formats.blank(formats.getValue(cert, ['date']), formats.formatDate)}}</b> - серия: {{formats.blank(formats.getValue(cert, ['series']))}} номер: {{formats.blank(formats.getValue(cert, ['number']))}} 
                </v-flex>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-info-form>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import vInfoForm from '../common/InfoForm'

  export default {
    name: 'v-loner-record-form',
    mixins: [apimix],
    components: {vInfoForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
      if (!this.model) {
        this.item = this.getItemNew()
      } else {
        this.item = this.model
        console.log('mounted', this.item)
      }
    },
    watch: {
      model: function (newVal, oldVal) {
        if (!newVal) {
          this.item = this.getItemNew()
        } else {
          this.item = newVal
        }
      }
    },
    computed: {
      ...mapGetters({
      }),
      title () {
        return `Запись ${this.item.grnip ? this.item.grnip : ''}`
      }
    },
    methods: {
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          date: null
        }
      }
    }

  }

</script>




// WEBPACK FOOTER //
// LonerRecordForm.vue?f38d0d30